<!--<app-use-app-notification></app-use-app-notification>-->
<!--</nav>-->
<div class=" pl-3 pr-3 d-none d-md-block " style="    background-color: #34c7c7;
    padding-top: 20px;
    padding-bottom: 25px;">

    <div class="pull-left">
        <img src="assets/logo_white.png" class="img" style="max-width: 220px;"/>
    </div>


    <div class="pull-right d-flex">

        <app-cart-icon style="    margin-right: 30px;"></app-cart-icon>
        <app-login-icon></app-login-icon>
<!--        <app-language-icon></app-language-icon>-->


    </div>

    <div class="d-none d-md-block">
        <div class="" style="height: 25px"></div>
<!--        <app-searchbar></app-searchbar>-->
    </div>


</div>


<nav class="d-sm-flex d-md-none navbar navbar-light bg-light"
     style="background-color: #34c7c7 !important;">

    <!--    <app-searchbar></app-searchbar>-->
    <a class="navbar-brand " href="#">
        <a [routerLink]="'/'"><img src="assets/logo_white.png" class="img"
                                   style="max-width: 220px; "/></a>
    </a>


    <div class="nav-item">
        <app-cart-icon></app-cart-icon>
    </div>
    <div class="nav-item">
        <app-login-icon></app-login-icon>
    </div>



    <div class="nav-item">
<!--        <app-language-icon></app-language-icon>-->
    </div>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <app-menu-mobile-bs></app-menu-mobile-bs>
    </div>
</nav>
<div class="d-sm-block d-md-none" style="background-color: #34c7c7 !important;">
    <app-searchbar></app-searchbar>
</div>

<!--<div class="main">-->
<!--    <app-menu></app-menu>-->
<!--    <div class="container-fluid" id="navigation" style="padding-left: 65px; font-weight: bold">-->

<!--    </div>-->
<!--</div>-->


